import React, { FC } from 'react';
import { Divider } from '../../divider/Divider';
import { HtmlContent } from '../../htmlContent/HtmlContent';
import { ArrowRight } from '../../icon';
import { LinkLabel } from '../../linkLabel';
import { LinkList } from '../../linkList/LinkList';
import { Section } from '../../section';
import { SimpleHero } from '../../simpleHero/SimpleHero';
import { StyledColumn, StyledTwoColumn } from '../../twoColumn/TwoColumn';

// Interface

export interface ErrorProps {
  heading: string;
  description?: string;
  image?: string;
  relatedLinks: RelatedLinksProps[];
}

export interface RelatedLinksProps {
  url: string;
  label: string;
}

// JSX

export const Error: FC<ErrorProps> = ({
  heading,
  image,
  description,
  relatedLinks,
}) => (
  <>
    {/* Component: Section */}
    <SimpleHero heading={heading} />

    <Section>
      {/* Component: Two Column */}
      <StyledTwoColumn>
        {/* Column two */}
        <StyledColumn>
          <HtmlContent>{description}</HtmlContent>
          <LinkList items={relatedLinks} />
          <Divider />
          <LinkLabel iconLeft={<ArrowRight />} label="Go to homepage" url="/" />
        </StyledColumn>

        {/* Column one */}
        <StyledColumn>
          {/* Featured image */}
          {image && <img src={image} alt="" style={{ width: '100%' }} />}
        </StyledColumn>
      </StyledTwoColumn>
    </Section>
  </>
);

export default Error;
